'use client';

import InlineToggleControl, {
  Props as BaseInlineToggleControlProps,
} from '@/components/Controls/InlineToggleControl';

import { useDemoContext } from './DemoContext';

type SliderControlProps = Omit<
  BaseInlineToggleControlProps,
  'value' | 'setValue'
>;

function DemoInlineToggleControl({
  id,
  ...props
}: SliderControlProps) {
  const context = useDemoContext();

  const { id: demoUnitId, state, setState } = context;
  const value = state[id];
  const htmlId = `${demoUnitId}_${id}`;

  return (
    <InlineToggleControl
      {...props}
      id={htmlId}
      value={value}
      setValue={(newValue: any) => {
        setState((state) => ({
          ...state,
          [id]: newValue,
        }));
      }}
    />
  );
}

export default DemoInlineToggleControl;
